// This is all you.
import './alpine';

import { Fancybox } from '@fancyapps/ui';

Fancybox.bind('[data-fancybox]');
